import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { href: '#home', label: 'Home' },
  { href: '#servizi', label: 'Servizi' },
  { href: '#benefici', label: 'Benefici' },
  { href: '#processo', label: 'Il Nostro Processo' },
  { href: '#normative', label: 'Normative' },
  { href: '#contatti', label: 'Contatti' }];


  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      'glass shadow-lg py-4' :
      'bg-transparent py-4'}`
      }>

      {/* Top bar - hidden on mobile */}
      <div className={`transition-all duration-300 hidden sm:block ${isScrolled ? 'h-0 opacity-0 overflow-hidden' : 'h-auto opacity-100'}`}>
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="flex justify-end items-center !text-sm !my-[5px] !pb-[8px] !gap-[24px] text-white/90">
            <a href={`tel:${companyInfo.phone}`} className="flex items-center hover:text-sky-300 gap-2">
              <Phone size={14} />
              {companyInfo.phone}
            </a>
            <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 hover:text-sky-300">
              <Mail size={14} />
              {companyInfo.email}
            </a>
          </div>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#home" onClick={(e) => scrollToSection(e, '#home')} className="flex items-center gap-2 sm:gap-3">
            <img
              src={isScrolled ? companyInfo.logoScrolled : companyInfo.logo}
              alt="RS Logo"
              className="h-8 sm:h-10 w-auto object-contain transition-all duration-300" />

            <div className={`${isScrolled ? 'text-slate-700' : 'text-white'}`}>
              <span className="block font-medium text-sm sm:text-lg leading-tight">Igienizzazione Canali</span>
            </div>
          </a>

          {/* Certifications */}
          <div className={`hidden xl:flex items-center gap-2 ml-4 ${isScrolled ? 'opacity-100' : 'opacity-90'}`}>
            <div className={`text-xs font-semibold px-3 py-1 rounded-full ${isScrolled ? 'bg-sky-100 text-sky-700' : 'bg-white/20 text-white'}`}>
              AIISA
            </div>
            <div className={`text-xs font-semibold px-3 py-1 rounded-full ${isScrolled ? 'bg-sky-100 text-sky-700' : 'bg-white/20 text-white'}`}>
              NADCA
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1 xl:ml-4">
            {navLinks.map((link) =>
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
              isScrolled ?
              'text-slate-700 hover:text-sky-600 hover:bg-sky-50' :
              'text-white/90 hover:text-white hover:bg-white/10'}`
              }>

                {link.label}
              </a>
            )}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button
              onClick={(e) => scrollToSection(e, '#contatti')}
              className={`${
              isScrolled ?
              'bg-sky-500 hover:bg-sky-600 text-white' :
              'bg-white text-slate-800 hover:bg-sky-50'}`
              }>

              Richiedi Preventivo
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg ${isScrolled ? 'text-slate-800' : 'text-white'}`}>

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden transition-all duration-300 overflow-hidden ${
        isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`
        }>

        <div className="glass mt-2 mx-4 rounded-xl shadow-xl p-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) =>
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="px-4 py-3 rounded-lg text-slate-700 hover:text-sky-600 hover:bg-sky-50 font-medium">

                {link.label}
              </a>
            )}
            <Button
              onClick={(e) => scrollToSection(e, '#contatti')}
              className="mt-2 bg-sky-500 hover:bg-sky-600 text-white w-full">

              Richiedi Preventivo
            </Button>
          </nav>
        </div>
      </div>
    </header>);

};

export default Header;